"use client";

import { SectionError } from "@/components/ui/section-error";

export default function StandaloneError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <SectionError
      error={error}
      reset={reset}
      scope="without-navbar"
      title={"This page failed to load"}
      description={"Retrying usually fixes it."}
    />
  );
}
